import { render, staticRenderFns } from "./SetupListView.vue?vue&type=template&id=2231bab6"
import script from "./SetupListView.vue?vue&type=script&lang=js"
export * from "./SetupListView.vue?vue&type=script&lang=js"
import style0 from "./SetupListView.vue?vue&type=style&index=0&id=2231bab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports